















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MainButton from '@/main-components/common/MainButton.vue';
import { PreCollectionsParams } from '@/resource/pre-collection/pre-collection.store';
import DropdownSubject from '@/main-components/pre-collections-new/DropdownSubject.vue';
import { InputData } from '../common/Form.vue';
import PreCollectionSubject from '@/main-components/pre-collections-new/PreCollectionSubject.vue';
import { Subject } from '@/resource/subject/subject.model';

@Component({
  components: {
    MainButton,
    DropdownSubject,
    PreCollectionSubject,
  },
})
export default class PreCollectionSearch extends Vue {
  @Prop({ required: true })
  queries!: PreCollectionsParams;

  @Prop({ required: true })
  dropdownSubjectInput: InputData;

  @Prop({ required: true })
  availSubjects: Subject[];

  submitInput: any;

  isFormLoading = false;

  screenWidth = window.innerWidth;

  async created() {
    this.firstFetch();
    window.addEventListener('resize', this.handleResize);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    this.screenWidth = window.innerWidth;
  }

  submitSearch() {
    this.$emit('reFetch', true);
  }

  firstFetch() {
    this.$emit('firstFetch');
  }

  reFetch(isChangeQuery: boolean) {
    this.$emit('reFetch', isChangeQuery);
  }

  addSubmitInput(submitInput: any) {
    if (submitInput) {
      this.submitInput = submitInput;
    }
  }

  updateIsFormLoading(loadingStatus: boolean) {
    this.isFormLoading = loadingStatus;
  }

  preventDefaultSubmit(event) {
    event.preventDefault();
  }

  @Watch('queries.subjectType')
  onSubjectTypeChange() {
    this.queries.keyword = '';
  }
}
